//* 组件库
import { utility, $loading } from "various-ui";
//* 公共组件
import type { DiagramsOption } from "@/components/visualizations/diagrams/default";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态数据
    const vars = {
        option: <DiagramsOption[]>[
            { key: "name", name: i18n.t("Gene"), width: 230, align: "left", control: "sort", explain: i18n.t("GeneDesc") },
            { key: "relevance", name: i18n.t("Association"), width: 190, align: "left", control: "sort", explain: i18n.t("AssociationDesc") },
            { key: "descript", name: i18n.t("Evidence"), width: 280, align: "left", control: "sort", explain: i18n.t("EvidenceDesc") },
            { key: "source", name: i18n.t("Source"), width: 248, align: "left", control: "sort" },
            { key: "drug", name: i18n.t("Drug"), width: 320, align: "left", control: "sort" },
            { key: "type", name: i18n.t("TumorType"), width: 320, align: "left", control: "sort" },
            { key: "medicate", name: i18n.t("Concomitant"), width: 210, align: "left", control: "sort", explain: i18n.t("ConcomitantDesc") },
        ],
    };

    //* 响应式数据
    const refs = {
        data: ref<any[]>([]),
        sort: reactive({ key: "", value: "" }),
        search: ref<{ key: string; value: string }[]>([]),
    };

    //* 函数列表
    const methods = {
        init: () => {
            $loading.open({ delay: 200, message: "" });
            api.frontend("/api/bio/tumor-taiger", {
                method: "POST",
                finally: () => $loading.close(),
                success: (response) => {
                    refs.data.value = response || [];
                },
            });
        },

        advanced: (data: { sort?: { key: string; value: string }; search?: { [name: string]: string } }) => {
            refs.sort.key = data.sort?.key || "";
            refs.sort.value = data.sort?.value || "";
            refs.search.value = [];
            for (const i in data.search) {
                refs.search.value.push({ key: i, value: data.search[i] });
            }
        },
    };

    //* 计算属性
    const computeds = {
        data: computed(() => {
            //* 数据初始化
            const result = utility.cloneDeep(refs.data.value)?.filter((value: any) => {
                for (let i = 0; i < refs.search.value.length; i++) {
                    if (!value[refs.search.value[i].key]?.toUpperCase()?.includes(refs.search.value[i].value.toUpperCase())) return false;
                }

                return true;
            });

            if (!refs.sort.key || !refs.sort.value) return result;
            else {
                return result.sort((a: any, b: any) => {
                    //* 转换为小写来确保大小写不敏感
                    const valueA = a[refs.sort.key]?.toLowerCase() || "";
                    const valueB = b[refs.sort.key]?.toLowerCase() || "";

                    //* 如果需要根据升序排序，直接返回valueA - valueB
                    //* 如果需要降序，则交换a和b的位置或者返回valueB - valueA
                    //* 如果两个值相等，则不需要交换位置
                    if ((refs.sort.value == "asc" && valueA < valueB) || (refs.sort.value == "desc" && valueB < valueA)) return -1;
                    else {
                        return 0;
                    }
                });
            }
        }),
    };

    //* 动态属性
    const binds = reactive({
        diagram: computed(() => {
            return {
                data: computeds.data.value,
                empty: i18n.t("NoData"),
                option: vars.option,
                searchHeader: true,
            };
        }),
    });

    return { vars, refs, binds, methods, computeds };
};
